/* Fetches and swaps the entire collection-grid card via Shopify's section rendering API when a sibling swatch is clicked. */
window.SiblingSwatchUpdater = window.SiblingSwatchUpdater || {
  sectionId: 'api-product-grid-item',
  selectors: {
    group: '.product__siblings',
    link: '.sibling__link',
    card: '[data-grid-item]',
  },

  init(context = document) {
    const groups = context.querySelectorAll(this.selectors.group);
    if (!groups.length) return;

    groups.forEach((group) => {
      if (group.dataset.siblingBound === 'true') return;
      group.dataset.siblingBound = 'true';

      group.addEventListener('click', (event) => {
        const link = event.target.closest(this.selectors.link);
        if (!link || !group.contains(link)) return;

        const card = link.closest(this.selectors.card);
        if (!card) return;

        event.preventDefault();
        this.swapCard(card, link);
      });
    });
  },

  swapCard(card, link) {
    const targetPath = link.getAttribute('href');
    if (card.dataset.url === targetPath) return;

    // Focus stays inside the new card, so the predictive search doesn't close when the old card is removed
    const hadFocus = card.contains(document.activeElement);

    // Keep a hover mega menu open while its product card is being swapped
    const disclosure = card.closest('hover-disclosure');
    if (disclosure) disclosure.dataset.keepOpen = 'true';
    const releaseDisclosure = () => {
      if (!disclosure) return;
      setTimeout(() => {
        delete disclosure.dataset.keepOpen;
        if (!disclosure.matches(':hover')) disclosure.hideDisclosure?.();
      }, 600); // old card is removed 500ms after the swap
    };

    card.siblingSwapController?.abort();
    const controller = new AbortController();
    card.siblingSwapController = controller;

    card.style.opacity = '0.6';
    card.style.pointerEvents = 'none';

    const separator = link.href.includes('?') ? '&' : '?';
    const requestUrl = `${link.href}${separator}section_id=${this.sectionId}`;

    fetch(requestUrl, { signal: controller.signal })
      .then((response) => response.text())
      .then((responseText) => {
        const fetchedCard = new DOMParser().parseFromString(responseText, 'text/html').querySelector(this.selectors.card);
        if (!fetchedCard) throw new Error('Sibling swap: no card found in response');

        let cardHtml = fetchedCard.outerHTML;
        cardHtml = cardHtml.replaceAll('||itemAnimationDelay||', '0');
        cardHtml = cardHtml.replaceAll('||itemAnimationAnchor||', fetchedCard.id ? `#${fetchedCard.id}` : '');

        const wrapper = document.createElement('div');
        wrapper.innerHTML = cardHtml;
        const newCard = wrapper.firstElementChild;

        newCard.querySelectorAll('[data-aos]').forEach((el) => {
          el.removeAttribute('data-aos');
          el.removeAttribute('data-aos-delay');
          el.removeAttribute('data-aos-duration');
          el.removeAttribute('data-aos-anchor');
          el.removeAttribute('data-aos-easing');
        });

        const order = card.style.getPropertyValue('--order-mobile');
        if (order) newCard.style.setProperty('--order-mobile', order);

        // Keeps a Rebuy recommendation slot tied to its recommended product, so the swapped card
        // still reports its clicks to Rebuy (see rebuy-recommendations.js).
        if (card.dataset.rebuyHandle) newCard.dataset.rebuyHandle = card.dataset.rebuyHandle;

        const swapWithUtility = window.HTMLUpdateUtility && typeof window.HTMLUpdateUtility.viewTransition === 'function';
        const onSwapped = (insertedCard) => {
          this.init(insertedCard);
          this.reinitYotpo();
          releaseDisclosure();
          if (hadFocus) {
            const focusTarget = insertedCard.querySelector(`${this.selectors.link}[href="${targetPath}"]`) || insertedCard.querySelector('a');
            focusTarget?.focus({ preventScroll: true });
          }
        };

        if (swapWithUtility) {
          window.HTMLUpdateUtility.viewTransition(card, newCard, [], [onSwapped]);
        } else {
          card.replaceWith(newCard);
          onSwapped(newCard);
        }
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        console.error(error);
        card.style.opacity = '';
        card.style.pointerEvents = '';
        releaseDisclosure();
      });
  },

  reinitYotpo() {
    if (window.yotpoWidgetsContainer && typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
      window.yotpoWidgetsContainer.initWidgets();
      return;
    }

    if (window.yotpo && typeof window.yotpo.refreshWidgets === 'function') {
      window.yotpo.refreshWidgets();
    }
  },
};

document.addEventListener('DOMContentLoaded', () => {
  SiblingSwatchUpdater.init();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches && node.matches(SiblingSwatchUpdater.selectors.group)) {
            SiblingSwatchUpdater.init(node);
          } else if (node.querySelector && node.querySelector(SiblingSwatchUpdater.selectors.group)) {
            SiblingSwatchUpdater.init(node);
          }
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
